import { namespaceCopyFor } from '@/i18n/ns';
import { localeLanguage } from '@/i18n/eu-locales';
import nativeConnectionsCopy from '@/i18n/ns/native-connections';

export function readAccessCopy(locale = 'en') {
  const copy = namespaceCopyFor(nativeConnectionsCopy, localeLanguage(locale));
  return {
    sectionTitle: copy.dbSectionTitle,
    sectionIntro: copy.dbSectionIntro,
    sectionNoneOn: copy.dbAccessOff,
    sectionSomeOn: copy.dbAccessEnabled,
    loading: copy.dbLoading,
    loadError: copy.dbLoadError,
    queryLimitLabel: copy.queryLimitLabel,
    queryLimitHint: copy.queryLimitHint,
    queryLimitDefault: copy.queryLimitDefault,
    queryLimitSource: copy.queryLimitSource,
    queryLimitSaving: copy.queryLimitSaving,
    queryLimitSaved: copy.queryLimitSaved,
    queryLimitError: copy.queryLimitError,
    queryLimitLoadError: copy.queryLimitLoadError,
    queryLimitRetry: copy.queryLimitRetry,
    seconds: copy.seconds,
    minutes: copy.minutes,
  };
}
